import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';
import { formConfig } from '../../../../utils/formConfig';

const selectSlice = (state: RootState) =>
  state.shapeVisualization || initialState;

const selectFields = (state: RootState, intl) => {
  const { shape } = selectSlice(state);
  return formConfig(shape || 'ring', intl);
};

export const selectShapeVisualisation = createSelector(
  [selectSlice],
  state => state,
);

export const selectShapeVisualisationShape = createSelector(
  [selectSlice],
  state => state.shape,
);
export const selectShapeVisualisationFieldFocused = createSelector(
  [selectSlice],
  state => state.fieldFocused,
);
export const selectShapeFormFields = intl =>
  createSelector([state => selectFields(state, intl)], state => state);

export const selectShape = createSelector([selectSlice], state => state.shape);
